import React from "react";
import { CircularProgress } from "@mui/material";
import { CheckCircle, Error as ErrorIcon } from "@mui/icons-material";
import { ImportProgress as ImportProgressType } from "../../types/UserImport";

interface ImportProgressProps {
  progress: ImportProgressType;
}

const ImportProgress: React.FC<ImportProgressProps> = ({ progress }) => {
  const getStageIcon = () => {
    switch (progress.stage) {
      case "complete":
        return <CheckCircle style={{ color: "#4caf50", fontSize: "20px" }} />;
      case "error":
        return <ErrorIcon style={{ color: "#f44336", fontSize: "20px" }} />;
      default:
        return <CircularProgress size={20} style={{ color: "#2aa7e0" }} />;
    }
  };

  const getStageColor = () => {
    switch (progress.stage) {
      case "complete":
        return "#4caf50";
      case "error":
        return "#f44336";
      default:
        return "#2aa7e0";
    }
  };

  const getStageText = () => {
    switch (progress.stage) {
      case "parsing":
        return "Parsing Excel file...";
      case "validating":
        return "Validating user data...";
      case "processing":
        return "Processing user information...";
      case "saving":
        return "Creating user accounts...";
      case "complete":
        return "Process completed successfully";
      case "error":
        return "An error occurred during processing";
      default:
        return progress.message;
    }
  };

  return (
    <div className="progress-container">
      <div className="progress-header">
        <div
          className="progress-text"
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          {getStageIcon()}
          {getStageText()}
        </div>
        <div className="progress-percentage">{progress.percentage}%</div>
      </div>

      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{
            width: `${progress.percentage}%`,
            backgroundColor: getStageColor(),
          }}
        />
      </div>

      {progress.current > 0 && progress.total > 0 && (
        <div
          style={{
            fontSize: "12px",
            color: "#666",
            marginTop: "8px",
            textAlign: "center",
          }}
        >
          {progress.current} of {progress.total} {progress.stage === "saving" ? "users" : "items"}{" "}
          processed
        </div>
      )}

      {progress.message && progress.message !== getStageText() && (
        <div
          style={{
            fontSize: "13px",
            color: "#424242",
            marginTop: "10px",
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderRadius: "6px",
            border: "1px solid #e0e0e0",
          }}
        >
          {progress.message}
        </div>
      )}
    </div>
  );
};

export default ImportProgress;
